import "@/styles/index.css";
import "@/features/bienvenida/device";
import "@/features/operational-flow/styles.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "motion/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { createQueryClient } from "@/app/query-client";
import { BandaEnsayo } from "@/app/BandaEnsayo";
import { PwaUpdates } from "@/app/PwaUpdates";
import { createRouter } from "@/app/router";
import { Guard } from "@/features/acceso/Guard";
import { PreviewProvider } from "@/features/operational-preview/model";
import { instalarRegistroDeErrores } from "@/lib/registro-de-errores";

// Lo que se rompa en el navegador llega al registro de errores del ERP (0182).
instalarRegistroDeErrores();

const container = document.getElementById("root");
if (!container) throw new Error("No existe #root en index.html");

createRoot(container).render(
  <StrictMode>
    <PwaUpdates />
    <QueryClientProvider client={createQueryClient()}>
      <BandaEnsayo />
      {/* Respeta la preferencia del sistema de reducir movimiento en todas las animaciones. */}
      <MotionConfig reducedMotion="user">
        {/* Sin sesión no se dibuja la aplicación. Quien protege los datos es la API;
            esto solo evita enseñar un armazón que no se puede usar. */}
        {import.meta.env.VITE_OPERATIONAL_PREVIEW === "true" ? (
          <PreviewProvider><Guard><RouterProvider router={createRouter()} /></Guard></PreviewProvider>
        ) : <Guard><RouterProvider router={createRouter()} /></Guard>}
      </MotionConfig>
    </QueryClientProvider>
  </StrictMode>,
);
